import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import notes from "../data/notes";
import "./Notes.css";

const NoteDetail = () => {
  const { slug } = useParams();
  const note = notes.find((n) => n.slug === slug);

  if (!note) {
    return <Navigate to="/notes" replace />;
  }

  if (note.driveLink) {
    window.location.href = note.driveLink;
    return null;
  }

  return (
    <section className="note-detail-page">
      <div className="note-detail-container">
        <Link to="/notes" className="back-link">
          ← Back to Notes
        </Link>

        <span className={`note-badge ${note.category}`}>
          {note.category === "doc" ? "Project Doc" : "Note"}
        </span>

        <h1>{note.title}</h1>

        <div className="note-tags">
          {note.tags.map((tag) => (
            <span key={tag} className="note-tag">
              {tag}
            </span>
          ))}
        </div>

        <div className="note-body">
          {note.content
            .trim()
            .split("\n\n")
            .map((block, i) => (
              <p key={i}>{block}</p>
            ))}
        </div>

        <div className="note-detail-cta">
          <Link to="/notes" className="btn view-projects">
            More Notes
          </Link>
          <Link to="/contact" className="btn contact-me">
            Let's Talk
          </Link>
        </div>
      </div>
    </section>
  );
};

export default NoteDetail;